import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyCall from "./StickyCall";
import CookieConsent from "./CookieConsent";
import NearestArea from "./NearestArea";
import { track } from "../lib/api";

export default function Layout() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("page_view", { path: loc.pathname });
  }, [loc.pathname]);
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <Header />
      <NearestArea />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyCall />
      <CookieConsent />
    </div>
  );
}
